import { API_PERMISSIONS } from "./_ApiPermissions";
import { API_BASE } from "./_Connection/_ApiBase";
import { API_SERVICES } from "./_Connection/ApiServices";
import { API_LOAD_ENDPOINTS } from "../../Web/Views/_ApiLoad.Endpoints";

export const API_CORE = {

    API_BASE: {
        URL: API_BASE.API_URL, STATIC: API_BASE.STATIC_URL,
        SOCKET: API_BASE.SOCKET_URL, MODE: API_BASE.BACKEND_MODE,
    },

    SERVICES: API_SERVICES,
    PERMISSIONS: API_PERMISSIONS,
    ENDPOINTS: API_LOAD_ENDPOINTS, // Cargamos todas las endpoints para que la API config sepa del endpoint
};